<div class="col-12" *ngIf="nextBilling">
  <div class="row">
    <div class="col-12 text-left pl-md-0 pr-md-3 px-0">
      <h2 class="font-weight-bold mb-4">{{ 'invoiceslist.Próxima facturación' | translate }}</h2>
    </div>

    <div class="card table-responsive" *ngFor="let tourBilling of nextBilling.tourBillings">
      <div class="row mb-4">
        <div class="col-12 text-left">
          <p class="name-provider mb-2">{{ tourBilling.tourResume.name | I18NTranslationSave: tourBilling.tourResume.nameMain }}</p>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-6 title">
          {{ 'invoiceslist.Idioma' | translate }}
        </div>
        <div class="col-6 title">
          {{ 'invoiceslist.Importe' | translate }}
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6 name-contact-provider font-weight-normal">
          {{ tourBilling.tourResume.languageTourGiven.name }}
        </div>
        <div class="col-6 name-contact-provider font-weight-normal">
          {{ tourBilling.billingDetails.commission }} &euro;
        </div>
      </div>
    </div>

    <div class="card table-responsive bg-grey-light-card-color">
      <div class="row mb-2">
        <div class="col-6 title">
          <p class="name-provider mb-2">{{ 'invoiceslist.Total' | translate }}</p>
        </div>
        <div class="col-6 title">
          <p class="name-provider mb-2">{{ nextBilling.total }} &euro;</p>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="col-12 mt-5">
  <div class="row">
    <div class="col-12 text-left pl-md-0 pr-md-3 px-0">
      <h2 class="font-weight-bold mb-4">{{ 'invoiceslist.Historial de facturación' | translate }}</h2>
    </div>
  </div>

  <div class="row empty-section" *ngIf="noResults">
    <div class="col-12 text-center my-auto">
      <img class="logo mb-4" src="assets/img/logo_opacity-21.png">
      <p>{{ 'invoiceslist.No se han encontrado resultados' | translate }}</p>
    </div>
  </div>
</div>

<div class="col-12 px-0" *ngIf="!noResults">
  <div class="card table-responsive" *ngFor="let invoice of invoices | paginate: pagination;">
    <div class="row mb-3">
      <div class="col-12 text-left">
        <p class="name-provider mb-2">{{ invoice.invoiceDate }}</p>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-10 title">
        {{ 'invoiceslist.Período de facturación' | translate }}: {{ invoice.invoiceMonthPeriod }}/{{ invoice.invoiceYearPeriod }}
      </div>

      <div class="col-2 text-right">
        <label class="btn-more-vert dropdown">
          <div class="dd-button">
            <img class="ic-mid" src="assets/img/ic_more-vert.svg">
          </div>

          <input type="checkbox" class="dd-input" id="test">

          <ul class="dd-menu">
            <li>
              <a (click)="onInvoiceDetails(invoice.id)">
                {{ 'invoiceslist.Ver detalles' | translate }}
              </a>
            </li>
            <li class="divider"></li>

            <li>
              <a (click)="onInvoiceDownload(invoice)">
                {{ 'invoiceslist.Descargar factura' | translate }}
              </a>
            </li>
          </ul>

        </label>
      </div>


    </div>

    <div class="row mb-2">
      <div class="col-6 title">
        {{ 'invoiceslist.Número de factura' | translate }}
      </div>
      <div class="col-6 title">
        {{ 'invoiceslist.Importe' | translate }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6 name-contact-provider">
        {{ invoice.serialNumber }}
      </div>
      <div class="col-6 name-contact-provider">
        {{ invoice.billingDetails.commission }} &euro;
      </div>
    </div>


    <div class="row mb-2">
      <div class="col-6 title">
        {{ 'invoiceslist.Estado' | translate }}
      </div>
      <div class="col-6 title">
        {{ 'invoiceslist.Tipo' | translate }}
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-6 name-contact-provider">
        <div [ngClass]="'status' | invoiceStateClassPipe: invoice.settledUp">
          <div class="dot"></div> {{ invoice.settledUp | invoiceStatePayment | translate }}
        </div>
      </div>
      <div class="col-6 name-contact-provider">
        <a *ngIf="invoice.paymentPending && !canReceivePayments" (click)="onGoToProfile()" placement="bottom" ngbTooltip="{{ 'invoiceslist.Cuenta de Stripe no conectada' | translate }}" tooltipClass="tooltip-info">
          <img class="ic-small" src="assets/img/ic_info_outlined_red.svg">
        </a>

        {{ invoice.chargePending | invoicePaymentTypeProviderPipe: invoice.chargeCompleted : invoice.paymentPending : invoice.paymentCompleted | translate }}
        {{ invoice.billingDetails.payment | invoicePaymentTypeAmountPipe }}
      </div>
    </div>



  </div>
</div>